import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import { COLORS } from '../../../utilities/constants'

function PercentOverdueGuage ({ gaugeValue }) {
  return (
    <div className={styles.container}>
      <div className={styles.guageContainer}>
        <svg width='240' height='140' viewBox='0 0 240 140'>
          <path
            d='M 35 120 A 85 85 0 0 1 205 120'
            fill='none'
            stroke={COLORS?.LIGHT_BLUE_GRAY}
            strokeWidth='50'
          />
          <path
            d='M 35 120 A 85 85 0 0 1 77.5 46.7'
            fill='none'
            stroke={COLORS?.PRIMARY}
            strokeWidth='50'
          />
          <path
            d='M 77.5 46.7 A 85 85 0 0 1 162.5 46.7'
            fill='none'
            stroke={COLORS?.SECONDARY}
            strokeWidth='50'
          />
          <path
            d='M 162.5 46.7 A 85 85 0 0 1 205 120'
            fill='none'
            stroke={COLORS?.WARNING}
            strokeWidth='50'
          />
          <g transform={`rotate(${-90 + gaugeValue * 1.8} 120 120)`}>
            <line
              x1='120'
              y1='120'
              x2='120'
              y2='45'
              stroke={COLORS?.DARK_MEDIUM_GRAY}
              strokeWidth='3'
            />
            <circle cx='120' cy='120' r='6' fill='#333' />
          </g>
        </svg>
        <div className={styles.guageLabel}>
          {gaugeValue}%
        </div>
      </div>
    </div>
  )
}

PercentOverdueGuage.propTypes = {
  gaugeValue: PropTypes.number
}

export default PercentOverdueGuage
